import { plans, type Plan } from '@/shared/constants/planData'
import { useFeatureFlags } from './useFeatureFlags'

export type PlanWithStatus = Plan & {
  isEnabled: boolean
}

export const usePlans = (): PlanWithStatus[] => {
  const [isExplorerPlanEnabled, isProPlanEnabled, isTeamsPlanEnabled] =
    useFeatureFlags(['plansExplorerPlan', 'plansProPlan', 'plansTeamsPlan'])

  return plans.map((plan) => {
    let isEnabled = false

    switch (plan.id) {
      case 'free':
        isEnabled = isExplorerPlanEnabled
        break
      case 'pro':
        isEnabled = isProPlanEnabled
        break
      case 'teams':
        isEnabled = isTeamsPlanEnabled
        break
      default:
        isEnabled = false
    }

    return {
      ...plan,
      isEnabled,
    }
  })
}
